import { applyTheme, type Theme } from '@cloudscape-design/components/theming';

const ACCENT = '#5b3df5';
const ACCENT_DARK = '#8b6df8';
const DANGER = '#e11d48';
const SUCCESS = '#10b981';
const WARNING = '#f59e0b';
const INFO = '#3b82f6';

const tokens: Theme['tokens'] = {
  fontFamilyBase: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  borderRadiusContainer: '8px',
  borderRadiusButton: '6px',
  borderRadiusInput: '6px',
  borderRadiusBadge: '4px',

  colorTextAccent: { light: ACCENT, dark: ACCENT_DARK },
  colorTextLinkDefault: { light: ACCENT, dark: ACCENT_DARK },
  colorTextLinkHover: { light: '#4527e0', dark: '#a98ffa' },
  colorBorderItemFocused: { light: ACCENT, dark: ACCENT_DARK },
  colorBackgroundButtonPrimaryDefault: { light: ACCENT, dark: ACCENT_DARK },
  colorBackgroundButtonPrimaryHover: { light: '#4527e0', dark: '#a98ffa' },
  colorBackgroundButtonPrimaryActive: { light: '#3a1fc7', dark: '#7a5cf5' },
  colorTextButtonPrimaryActive: { light: '#ffffff', dark: '#ffffff' },

  colorBackgroundStatusError: { light: '#fef2f2', dark: '#3f1416' },
  colorTextStatusError: { light: DANGER, dark: '#fb7185' },
  colorBackgroundStatusSuccess: { light: '#ecfdf5', dark: '#0f2e22' },
  colorTextStatusSuccess: { light: SUCCESS, dark: '#34d399' },
  colorBackgroundStatusWarning: { light: '#fffbeb', dark: '#3a2a0f' },
  colorTextStatusWarning: { light: WARNING, dark: '#fbbf24' },
  colorBackgroundStatusInfo: { light: '#eff6ff', dark: '#0f1f3a' },
  colorTextStatusInfo: { light: INFO, dark: '#60a5fa' },
};

export const VEXTURA_THEME: Theme = { tokens };

export function applyVexturaTheme(): { reset: () => void } {
  return applyTheme({ theme: VEXTURA_THEME });
}

export const VEXTURA_PALETTE = {
  accent: ACCENT,
  accentDark: ACCENT_DARK,
  danger: DANGER,
  success: SUCCESS,
  warning: WARNING,
  info: INFO,
} as const;
